if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.mediaItems = Array.from(this.querySelectorAll('.product-media-modal__content > [data-media-id]'));
        this.currentIndex = 0;

        this.prevButton = this.querySelector('[data-modal-prev]');
        this.nextButton = this.querySelector('[data-modal-next]');
        this.currentLabel = this.querySelector('[data-modal-current]');
        this.totalLabel = this.querySelector('[data-modal-total]');

        // The base media-modal closes on any background pointerup (mouse) that
        // isn't a video/3D model. Stop nav/counter clicks from bubbling to it,
        // otherwise clicking an arrow would exit the lightbox instead of paging.
        const stopClose = (el) => {
          if (!el) return;
          el.addEventListener('pointerup', (e) => e.stopPropagation());
        };
        stopClose(this.prevButton);
        stopClose(this.nextButton);
        stopClose(this.querySelector('.product-media-modal__counter'));

        if (this.prevButton) {
          this.prevButton.addEventListener('click', (e) => {
            e.preventDefault();
            this.step(-1);
          });
        }
        if (this.nextButton) {
          this.nextButton.addEventListener('click', (e) => {
            e.preventDefault();
            this.step(1);
          });
        }
        this.addEventListener('keydown', (e) => {
          if (this.mediaItems.length <= 1) return;
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            this.step(-1);
          } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            this.step(1);
          }
        });

        // Hide arrows / counter when there is only a single image.
        this.toggleAttribute('data-single', this.mediaItems.length <= 1);
        if (this.totalLabel) this.totalLabel.textContent = this.mediaItems.length;
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const openedId = this.openedBy ? this.openedBy.getAttribute('data-media-id') : null;
        const idx = this.mediaItems.findIndex((el) => el.getAttribute('data-media-id') === openedId);
        this.setActive(idx >= 0 ? idx : 0);
      }

      step(delta) {
        if (!this.mediaItems.length) return;
        const n = this.mediaItems.length;
        this.setActive((this.currentIndex + delta + n) % n);
      }

      setActive(index) {
        if (!this.mediaItems.length) return;
        this.currentIndex = index;

        this.mediaItems.forEach((el, i) => {
          el.classList.toggle('active', i === index);
        });

        const activeMedia = this.mediaItems[index];

        // Load deferred (e.g. YouTube) content when its slide becomes active.
        if (activeMedia && activeMedia.nodeName === 'DEFERRED-MEDIA') {
          const template = activeMedia.querySelector('template');
          const content = template ? template.content : null;
          if (content && content.querySelector('.js-youtube') && typeof activeMedia.loadContent === 'function') {
            activeMedia.loadContent();
          }
        }

        const container = this.querySelector('[role="document"]');
        if (container) {
          container.scrollTop = 0;
          container.scrollLeft = 0;
        }

        if (this.currentLabel) this.currentLabel.textContent = index + 1;
        if (this.totalLabel) this.totalLabel.textContent = this.mediaItems.length;
      }
    }
  );
}
